<template>
  <div class="TrafficMapBackground">
    <div id="container" @click="handleClick"></div>
    <div class="road-condition">
      <div class="row">
        <div class="color-block" :style="{ background: 'red' }"></div>
        <div class="title">当前路况拥堵</div>
      </div>
      <div class="row">
        <div class="color-block" :style="{ background: '#fecb36' }"></div>
        <div class="title">当前行驶车辆缓慢</div>
      </div>
      <div class="row">
        <div class="color-block" :style="{ background: '#2ed268' }"></div>
        <div class="title">当前路况很好，畅通</div>
      </div>
    </div>
  </div>
</template>

<script>
import { mapMutations, mapState } from 'vuex';
export default {
  name: 'TrafficMapBackground',
  props: {
    /* 等比缩放需要使用ProjectInfo
     ProjectInfo.ScreenRatio: {
        w_Ratio: 100,  单位%   宽度缩放比
        h_Ratio: 100,  单位%   高度缩放比
      }, 
    */
    ProjectInfo: Object,
    Configuration: Object,
  },
  data() {
    return {
      mywinmap: null, // 地图
      mywpoint: null, // 点位
      mapType: '2', // 地图类型
      mapBasicSetting: null, // 地图基本设置
      vatchvalue: '',
      mykey: '',
    };
  },
  computed: {
    ...mapState({
      // 视频
      currentRoadCood: state => state.currentRoadCood,
      // 点位
      // pointList: state => state.pointList,
      // currentMonitor: state => state.currentMonitor,
    }),
  },
  mounted() {
    this.mapType = this.Configuration.propertyData.mapType.value;
    this.mapBasicSetting = this.Configuration.propertyData.mapBasicSetting.value;
    // this.mykey = this.Configuration.propertyData.MapKey.value;
    this.$nextTick(() => {
      this.initMap();
      // console.log(this.mywpoint, 'this.mywpoint');
    });
  },
  watch: {
    currentRoadCood: {
      handler: function (nV) {
        this.roadCoodChange(nV);
      },
    },
    Configuration: {
      deep: true,
      handler: function (newValue) {
        this.initMap();
      },
    },
  },
  methods: {
    // 地图点击
    handleClick(e) {
      console.log('!!!!!!!!!!', e);
      e.stopPropagation();
      this.$store.commit('set_CurrentConfigration', this.Configuration);
      this.$store.commit('set_ContextMenu', {
        isOpen: false,
      });
    },
    // 点击路况
    roadCoodChange(road) {
      console.log('移动1', road);
      this.mywinmap.moveMapContor(road.longitude, road.latitude);
    },

    // 点位 视频 标点
    pointVideoPoint(list) {
      console.log('list.Switchvalue', list);
      if (this.vatchvalue == 'point') {
        this.mywinmap.markerlist(list.Video, {
          groupName: this.vatchvalue,
          infowindowStartIndex: 0,
          infowindowType: '1',
          infowindowHeight: '220px',
          infowindowWidth: '320px',
        });
      } else {
        this.mywinmap.markerlist(list.Video, {
          groupName: this.vatchvalue,
          infowindowStartIndex: 0,
          infowindowType: '6',
          infowindowHeight: '360px',
          infowindowWidth: '480px',
          infowindowtop: '0.0024',
        });
      }
    },
    // 初始化地图
    initMap() {
      this.mywinmap = null;
      let map = document.getElementById('TrafficMapBackground');
      console.log('map', map);
      this.mywinmap = new winMap('container', {
        maptype: this.mapType.type, // 地图类型
        key: 'WKvseQPCaNwRbBDnLJtnm',
        // key: this.mykey,
        maplon: this.mapBasicSetting.coordinate.lng,
        maplat: this.mapBasicSetting.coordinate.lat,
        level: this.mapBasicSetting.zoom + '',
        // http_server: 'http://gisapi.xyabcd.com',
        region: '清远市',
        jwt: localStorage.getItem('_t'),
      });
      window.mywinmap = this.mywinmap;
      // this.mywinmap.addregion();
      setTimeout(() => {
        window.mywinmap.addRow();
      }, 500);
    },
  },
  Configuration: {
    componentTitle: '交通地图背景',
    componentName: 'TrafficMapBackground',
    componentOverViewImg: './img/backgrounds/MapBackground.png',
    id: 'TrafficMapBackground',
    style: {
      backgroundColor: '#19242D',
    },
    propertyData: {
      mapBasicSetting: {
        value: {
          coordinate: {
            lng: '116.39156',
            lat: '39.90714',
          },
          zoom: 15,
          is3dMap: false,
        },
        propertyComponentName: 'mapBasicSetting',
        lable: '地图基本设置',
      },
      mapType: {
        value: {
          type: '2',
        },
        propertyComponentName: 'mapType',
        lable: '地图类型',
      },
      MapKey: {
        propertyComponentName: 'MapKeyConfiger',
        value: {
          borderComponentName: 'WKvseQPCaNwRbBDnLJtnm',
        },
      },
      // mapPopupData: {
      //   propertyComponentName: 'MapPopup',
      //   value: {
      //     borderComponentName: 'point'
      //   },
      // },
      // mapStyle: {
      //   value: {
      //     checkedId: 0,
      //     plan: {
      //       plancode: '575d2a1a8d57786ac4f8373f98808cef',
      //     },
      //   },
      //   propertyComponentName: 'mapStyle',
      //   lable: '个性化样式',
      // },
    },
  },
};
</script>

<style lang="scss" scoped>
.TrafficMapBackground {
  position: absolute;
  width: 100%;
  height: 100%;
  z-index: 0;

  #container {
    width: 100%;
    height: 100%;
  }

  .road-condition {
    position: absolute;
    bottom: 20%;
    left: 10%;
    width: 20vw;
    min-width: 200px;
    min-height: 100px;
    height: 16vh;
    background: #2f5c6b9a;
    border-radius: 10px;

    display: flex;
    justify-content: center;
    flex-direction: column;
    align-items: center;
    justify-content: space-evenly;
    background: url('../../../assets/img/mapbk.png') no-repeat;
    background-size: 100% 100%;

    .row {
      width: 65%;
      display: flex;
      justify-content: space-between;
      align-items: center;

      .color-block {
        width: 10%;
        min-width: 30px;
        height: 6px;
        border-radius: 4px;
      }

      .title {
        width: 70%;
        color: #fff;
        text-align: left;
      }
    }
  }
}

.mapbackground {
  overflow: hidden;
  width: 100%;
  height: 100%;
  margin: 0;
  font-family: '微软雅黑';
}

:deep().jqsbInfoBgleft {
  img {
    // width: 111px !important;
    // height: 114px !important;
    max-width: none;
  }
}

:deep().wzks_scenicImg2 {
  width: 100% !important;
}
</style>
